<template>

    <div class="container-fluid">
        <div class="row">
            <div class="col-6">
               
            </div>
            <div class="col-6">
                <ol style="float: right;" class="breadcrumb ">
                    <a v-show="opcrud > 0" @click.prevent="mtdcancelaredicao()"
                        class="btn btn-info btn-sm button-voltar"><i class="fa fa-arrow-alt-circle-left"></i>
                        Voltar
                    </a>

                    <li style="padding-left: 15px;" class="breadcrumb-item"><a href="/inicio">Início</a></li>
                    <li class="breadcrumb-item"><a @click.prevent="mtdcancelaredicao()">Justificativas</a></li>
                    <li class="breadcrumb-item active">{{ descop.toLocaleLowerCase() }}</li>
                </ol>
            </div>

        </div>
        <div id="pnlista">
            <div class="card mb-3">
                <div class="card-header">
                    <div class="row">
                        <div class="col-lg-12">
                            <a @click.prevent="mtdnovo()" class="btn btn-info">
                                <i class="bi bi-calendar-plus"></i> Nova Justificativa
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card mb-3">
                <div class="card-header">
                    <div class="row">
                        <div class="col-lg-2">
                            <div class="form-group">
                                <label for="edtipopesq">Por</label>
                                <select class="form-select form-control" v-model="pfiltro"
                                    aria-label="Default select example">
                                    <option value="0">Código</option>
                                    <option value="1">Descrição</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="form-group">
                                <label for="">pesquisa</label>
                                <input type="text" v-model="pconteudo" class="form-control" id="nome" required="">
                            </div>
                        </div>
                        <div class="col-lg-2">
                            <div class="form-group">
                                <label for="">Limite
                                </label>
                                <select class="form-select form-control" v-model="pqtdregistros"
                                    aria-label="Default select example">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                    <option value="200">200</option>
                                    <option value="500">500</option>
                                    <option value="1000">1000</option>
                                    <option value="99999999">Todos</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-lg-2" style="padding-top: 25px;">
                            <a @click.prevent="mtdexecutapesquisa()" style="width: 100%;" class="btn btn-info">
                                <i class="bi bi-search"></i> Listar
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <EasyDataTable :headers="headers" :items="lstjustificativas" :pagination="false" hide-footer
                        empty-message="Nenhum dado encontrado"
                        table-class-name="table table-hover text-nowrap table-bordered table-striped">
                        <template #item-acoes="{ id, status }">
                            <div style="display: flex; justify-content: center;">
                                <a @click="mtdalterar(id)" class="btn btn-sm btn-warning">
                                    <i class="bi bi-pencil-square"></i>
                                </a>
                                <a style="margin-left: 15px;" @click="mtdvisualizar(id)" class="btn btn-sm btn-info">
                                    <i class="bi bi-eye"></i>
                                </a>
                                <button style="margin-left: 15px;" type="button" class="btn btn-sm btn-danger"
                                    @click="mtdexcluir(id)">
                                    <i class="bi bi-trash"></i>
                                </button>

                                <button v-if="status == 0" style="margin-left: 15px;" type="button" class="btn btn-sm btn-success"
                                    @click="mtdefetivar(id)">
                                    <i class="bi bi-check-circle"></i>
                                </button>
                                <button v-if="status == 1" style="margin-left: 15px;" type="button" class="btn btn-sm btn-secondary"
                                    @click="mtdcancelar(id)">
                                    <i class="bi bi-x-circle"></i>
                                </button>

                            </div>
                        </template>

                        <template #item-nome="{ tipo, nome }">
                            {{ nome }}
                        </template>

                        <template #item-tipo="{ tipo }">
                            <span v-if="tipo == 0">Atestado Médico</span>
                            <span v-else-if="tipo == 1">Declaração</span>
                            <span v-else-if="tipo == 2">Férias</span>
                            <span v-else>Outros</span>
                        </template>

                        <template #item-status="{ status }">
                            <span v-if="status == 0" class="badge bg-primary">Aberto</span>
                            <span v-else-if="status == 1" class="badge bg-secondary">Efetivado</span>
                            <span v-else class="badge bg-danger">Cancelado</span>
                        </template>

                    </EasyDataTable>
                </div>
                <div class="card-footer">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <vue-awesome-paginate :total-items="pqtd_total_registros" :items-per-page="pqtdregistros"
                                    :max-pages-shown="2" v-model="pagina_atual" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="pncadastro">
            <div class="card">
                <div class="card-body">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-2">
                                <div class="form-group">
                                    <label for="edid">Código</label>
                                    <input type="text" v-model="vid" class="form-control" id="edid" disabled>
                                </div>
                            </div>

                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <span class="lblselect2">Colaborador:</span>
                                <select id="cbcolaborador" data-placeholder="Selecione um colaborador" data-allow-clear="true"
                                    style="width:100%;" v-model="vidcolaborador" :disabled="ativadesativa">
                                </select>
                            </div>

                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <div class="form-group">
                                    <label for="cbTipo">Tipo</label>
                                    <select id="cbTipo" class="form-select form-control" v-model="vtipo" :disabled="ativadesativa">
                                        <option value="0">Atestado Médico</option>
                                        <option value="1">Declaração</option>
                                        <option value="2">Ferias</option>
                                        <option value="3">Outros</option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-lg-2" >
                                <div class="form-group">
                                    <label for="">Data inicio</label>
                                    <input type="date" v-model="vdtjustificativa" :disabled="ativadesativa" class="form-control">
                                </div>
                            </div>

                            <div class="col-lg-2" >
                                <div class="form-group">
                                    <label for="">Data fim</label>
                                    <input type="date" v-model="vdtfimjustificativa" :disabled="ativadesativa" class="form-control">
                                </div>
                            </div>

                            <div class="col-sm-12 col-md-2 col-lg-2" style="padding-top: 20px;" >
                                <span v-if="vstatus == 0" class="badge b-crud bg-primary">Aberto</span>
                                <span v-if="vstatus == 1" class="badge b-crud bg-secondary">Efetivado</span>
                                <span v-if="vstatus == 2" class="badge b-crud bg-danger">Cancelado</span>
                            </div>

                            <div class="col-sm-12 col-md-12 col-lg-12">
                                <div class="form-group">
                                    <label for="edobs">Observação</label>
                                    <textarea v-model="vobs" class="form-control" id="edobs" :disabled="ativadesativa" rows="3"></textarea>
                                </div>
                            </div>    

                            <div class="col-sm-12 col-md-12 col-lg-12" style="margin-top: 15px;">
                                <div class="col-md-12 border rounded" style="padding: 15px;">
                                    <div v-if="lstarquivos.length > 0" class="row g-3">
                                        <div v-for="(imagem, index) in lstarquivos" v-bind:key="index" class="col-6 col-sm-4 col-md-3 col-lg-2 d-flex flex-column align-items-center">
                                            <div class="position-relative" style="width: 100%; max-width: 150px;">
                                                <img v-if="mtdehimagem(imagem.patharquivo)" class="img-thumbnail img-produto w-100" style="height: 150px; object-fit: cover;" v-bind:src="pathimgview+imagem.patharquivo">
                                                <div v-else class="img-thumbnail img-produto d-flex align-items-center justify-content-center w-100" style="height: 150px;">
                                                    <i :class="mtdobtericonearquivo(imagem.patharquivo)" style="font-size: 32px;"></i>
                                                </div>
                                                <div class="d-flex gap-1 mt-2 justify-content-center w-100">
                                                    <button v-if="parseInt(opcrud) < 3" type="button" class="btn btn-danger btn-sm" @click.prevent="mtdexcluirarq(imagem.patharquivo)"><i class="fa fa-trash"></i></button>
                                                    <button type="button" class="btn btn-info btn-sm" @click.prevent="mtdbaixararquivo(imagem.patharquivo)"><i class="bi bi-download"></i></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else class="row">
                                        <div class="col-md-12 text-center py-5">
                                            <h6 style="font-size: 12px;">Sem arquivos para visualização</h6>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="parseInt(opcrud) < 3" class="col-md-12 text-center" style="margin-top: 15px;">
                                    <input
                                        type="file"
                                        id="ipselecionarimg"
                                        accept="image/png, image/jpeg, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                        @change="mtdselecionararq"
                                        style="display: none;"
                                        ref="if_arq">
                                    <button type="button" @click="$refs.if_arq.click()" class="btn btn-primary btn-sm"><i class="fa fa-picture-o"></i> Adicionar arquivo</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-10 col-md-10 col-sm-12">

                            </div>
                            <div class="col-lg-2 col-md-2 col-sm-12">
                                <button v-show="opcrud == 1" :disabled="validou" @click.prevent="mtdgravar()"
                                    style="width: 100%;" id="btgravar" class="btn btn-info">
                                    <i class="bi bi-save"></i> Gravar
                                </button>
                                <button v-show="opcrud == 2" :disabled="validou" @click.prevent="mtdgravar()"
                                    style="width: 100%;" id="btgravar" class="btn btn-warning">
                                    <i class="bi bi-pencil"></i> Alterar
                                </button>
                                <button v-show="opcrud == 3" :disabled="validou" @click.prevent="mtdgravar()"
                                    style="width: 100%;" id="btgravar" class="btn btn-danger">
                                    <i class="bi bi-trash"></i> Excluir
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


</template>

<script>
// @ is an alias to /src
import Swal from 'sweetalert2'
import util from '../util.js'
import EasyDataTable from 'vue3-easy-data-table';
import 'vue3-easy-data-table/dist/style.css';
import router from '@/router/index.js';


import { ref } from "vue";

const onClickHandler = (page) => {
    console.log(page);
};

const pagina_atual = ref(1);


export default {
    name: 'justificativas', // Renomeado

    data() {
        return {

            //variaveis do cadastro - JUSTIFICATIVAS
            opcrud : 0,
            vid    : 0,
            vobs: '', 
           
            vtipo  : 0,
            vstatus: 0,

            modulo : 'JUSTIFICATIVAS', // Renomeado
            descop : '',

            //paginação
            pqtd_total_registros: 10,
            pagina_atual: 1,
            pqtdregistros: 10,
            pqtd_paginas: 0,

            arqselecionado: null,
            pathimgview   : util.servidor +'/',   


            //filtros
            pfiltro: 1,
            pconteudo: '',
           

            lstarquivos: [],
            vpatharquivos: '',

            vidcolaborador: null,
            vdtjustificativa: '',
            vdtfimjustificativa: '',

            ativadesativa: false,

            headers: [ // Novos cabeçalhos da tabela
                { text: 'Ações',  value: 'acoes', sortable: false, width: 80 },
                { text: 'Cód.',   value: 'id', sortable: true, width: 80 },
                { text: 'Nome',   value: 'nomecolaborador', sortable: true },
                { text: 'Tipo',   value: 'tipo', sortable: true },
                { text: 'Status', value: 'status', sortable: true },
                { text: 'Data',   value: 'dtjustificativa', sortable: false }, 
            ],


            lstjustificativas: []

        }
    },
    components: {
        EasyDataTable,
    },
    methods: {

        mtdbaixararquivo(patharquivo){
            const link = document.createElement('a');
            link.href = util.servidor + '/'+ patharquivo;
            link.target = '_blank';
            link.download = patharquivo.split('/').pop();
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        mtdehimagem(path){
            const extensoes_imagem = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
            const extensao = path.split('.').pop().toLowerCase();
            return extensoes_imagem.includes(extensao);
        },
        mtdobtericonearquivo(caminho) {
                const extensao = caminho.split('.').pop().toLowerCase();
                
                const iconesArquivos = {
                    'pdf': 'bi bi-file-pdf',
                    'doc': 'bi bi-file-word',
                    'docx': 'bi bi-file-word',
                    'xls': 'bi bi-file-earmark-spreadsheet',
                    'xlsx': 'bi bi-file-earmark-spreadsheet',
                    'ppt': 'bi bi-file-earmark-presentation',
                    'pptx': 'bi bi-file-earmark-presentation',
                    'txt': 'bi bi-file-text',
                    'zip': 'bi bi-file-earmark-zip',
                    'rar': 'bi bi-file-earmark-zip'
                };
                
                return iconesArquivos[extensao] || 'bi bi-file-earmark';
            
          }, 
          mtdefetivar(id){
    
            let vself = this;
            Swal.fire({
                title: "Confirmação",
                text: 'Confirma efetivação ?',
                icon: "warning",
                customClass: {
                    confirmButton: "conf btn btn-success",
                    cancelButton: "btn btn-danger"
                },
                showCancelButton: true,
                confirmButtonColor: "black",
                cancelButtonText: "Não",
                cancelButtonColor: "#d33",
                confirmButtonText: "Sim"
            }).
                then((result) => {
                    if (result.isConfirmed) {
                        let loader       = vself.$loading.show();
                        let parametros      = [
                            {parametro: 'op',               valor  : "efetivar"},
                            {parametro: 'idempresa',        valor  : vself.$store.state.usuario.idempresa },
                            {parametro: 'id',               valor  : id},
                        ];
                        let retorno     = util.reqaxios(parametros, 'post',  util.servidor+'/controller/justificativas.php');
                        retorno.then(function (response) {
                            if ($.isNumeric(response.data)){
                                util.notif('success', 'Informação!', 'Registro efetivado com sucesso!');
                                vself.pfiltro = 0;
                                vself.pconteudo = id;
                                vself.mtdexecutapesquisa();
                                
                            }else{
                                util.notif('error', 'Erro!', response.data);
                            }
                            vself.$loading.hide();
                        }).catch(function (response) {
                            vself.$loading.hide();
                            util.notif('error', 'Erro!', response.message);
                        });
                        
                    } else {
                        
                    }
                });

            
          },

          mtdcancelar(id) {
            let vself = this;
            Swal.fire({
                title: "Confirmação",
                text: 'Confirma cancelamento?',
                icon: "warning",
                customClass: {
                    confirmButton: "conf btn btn-success",
                    cancelButton: "btn btn-danger"
                },
                showCancelButton: true,
                confirmButtonColor: "black",
                cancelButtonText: "Não",
                cancelButtonColor: "#d33",
                confirmButtonText: "Sim"
            }).then((result) => {
                if (result.isConfirmed) {
                    let loader = vself.$loading.show();
                    let parametros = [
                        {parametro: 'op', valor: "cancelar"},
                        {parametro: 'idempresa',        valor  : vself.$store.state.usuario.idempresa },
                        {parametro: 'id', valor: id},
                    ];
                    let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/justificativas.php');
                    retorno.then(function (response) {
                        if ($.isNumeric(response.data)) {
                            util.notif('success', 'Informação!', 'Registro cancelado com sucesso!');
                            vself.pfiltro = 0;
                            vself.pconteudo = id;
                            vself.mtdexecutapesquisa();
                        } else {
                            util.notif('error', 'Erro!', response.data);
                        }
                        vself.$loading.hide();
                    }).catch(function (response) {
                        vself.$loading.hide();
                        util.notif('error', 'Erro!', response.message);
                    });
                }
            });
          },
          
          mtdexcluirarq(patharquivo){
            let vself = this;
            let loader       = vself.$loading.show();
            let localarquivo = 'arquivos/justificativas/' + vself.$store.state.usuario.idempresa +'/'+ vself.vpatharquivos;

            let parametros      = [
            {parametro: 'op',               valor  : "excluirarquivo"},
            {parametro: 'patharquivo',      valor  : patharquivo},
            {parametro: 'idempresa',        valor  : vself.$store.state.usuario.idempresa },
            {parametro: 'localarquivo',     valor  : localarquivo}

            ];
            let retorno     = util.reqaxios(parametros, 'post',  util.servidor+'/controller/utilitario.php');
            retorno.then(function (response) {
            if ($.isNumeric(response.data.inf)){
                util.notif('success', 'Informação!', 'Arquivo excluído com sucesso!');
                vself.lstarquivos = [];
                vself.lstarquivos = vself.mtdordenaarquivos(response.data.arquivos);
            }else{
                util.notif('error', 'Erro!', 'Descrição do erro: '+response.data);
            }
                vself.$loading.hide();
            }).catch(function (response) {
                vself.$loading.hide();
                util.notif('error', 'Erro!', 'Descrição do erro: '+response.message);
            });
        },
        mtdordenaarquivos(lstarquivos){
            let lstordenada = lstarquivos.sort((a, b) => {
                if (a.arquivo < b.arquivo) {
                    return -1;
                }
                if (a.arquivo > b.arquivo) {
                    return 1;
                }
                return 0;
            });
            return lstordenada;
        },
        mtdselecionararq(event){
            let vself = this;
            vself.$loading.show();
            vself.arqselecionado = event.target.files[0];
            let localsalvar = 'arquivos/justificativas/' + vself.$store.state.usuario.idempresa +'/'+ vself.vpatharquivos;
            let extarquivo  = vself.arqselecionado.name.split('.').pop()
            let nomearquivo = '1.' + extarquivo;
            if(vself.lstarquivos.length > 0){
                nomearquivo = (parseInt(vself.lstarquivos.pop().arquivo.split('.')[0]) + 1) + '.' + extarquivo;
            }

            let parametros      = [
                {parametro: 'arquivo',          valor  : vself.arqselecionado},
                {parametro: 'localsalvar',      valor  : localsalvar},
                {parametro: 'nomearquivo',      valor  : nomearquivo},
            ];
            let retorno     = util.reqaxios(parametros, 'post',  util.servidor + '/controller/uploadfile.php');
            retorno.then(function (response) {
                if ($.isNumeric(response.data.inf)){
                  
                    vself.lstarquivos = [];
                    vself.lstarquivos = vself.mtdordenaarquivos(response.data.arquivos);
                    console.log(vself.lstarquivos);
                    vself.arqselecionado = null;
                    $('#ipselecionarimg').val('');
                    vself.$loading.hide();

                }else{
                   vself.$loading.hide();
                }
              
            }).catch(function (response) {
               vself.$loading.hide();
            });
        },
        mtdfiltropesquisa() {
            let rfiltro = '';
            if (parseInt(this.pfiltro) === 0) {
                rfiltro = this.pconteudo === '' ? '' : ' and j.id=' + this.pconteudo;
            } else {
                rfiltro = this.pconteudo === '' ? '' : ' and j.upper(nomecolaborador) like upper("' + this.pconteudo + '%")';
            }
            return rfiltro;
        },
        mtdexecutapesquisa() {
            var vself = this;
            let filtro = vself.mtdfiltropesquisa();
            this.pagina_atual = 1;
            let parametros = [
                { parametro: 'idusuario', valor: vself.$store.state.usuario.idusuario },
                { parametro: 'op',        valor: 'qtdregistros' },
                { parametro: 'idempresa', valor: vself.$store.state.usuario.idempresa },
                { parametro: 'filtro',    valor: filtro }
            ];
            // URL do controlador alterada
            let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/justificativas.php'); 
            retorno.then(function (response) {
                vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                let qtdpg = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                vself.pqtd_paginas = qtdpg > 0 ? qtdpg : 1;
                vself.mtdcarregaitem(1);
            }).catch(function (response) {
                //alert('Erro ao consultar registros');
            });
        },
        mtdcarregaitem(ipagina) {
            let vself = this;
            let filtro = vself.mtdfiltropesquisa();
            vself.$loading.show();
            let parametros = [
                { parametro: 'op',        valor: 'listagem' },
                { parametro: 'idusuario', valor:  vself.$store.state.usuario.idusuario },
                { parametro: 'idempresa', valor:  vself.$store.state.usuario.idempresa },
                { parametro: 'diretorioarquivos', valor: 'arquivos/justificativas/' + vself.$store.state.usuario.idempresa},
                { parametro: 'filtro',    valor:  filtro },
                { parametro: 'limit',     valor:  vself.pqtdregistros },
                { parametro: 'offset',    valor: (parseInt(ipagina) - 1) * parseInt(vself.pqtdregistros) },
            ];
            // URL do controlador alterada
            let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/justificativas.php'); 
            retorno.then(function (response) {
                // Mapeia os dias da semana para string antes de exibir na tabela
                vself.lstjustificativas = JSON.parse(JSON.stringify(response.data)).map(item => ({
                    ...item,
                    dias_semana: item.dias_semana ? item.dias_semana.split(',').map(d => diasMapeamento[parseInt(d.trim())]).join(', ') : ''
                }));
                vself.$loading.hide();
            }).catch(function (response) {
                vself.lstjustificativas = [];
                vself.$loading.hide();
            });
        },

        mtdpreparacrud(op) {
            this.opcrud = op;
        },

        resetarDados() {
            this.vid              = '';
            this.vidcolaborador   = null;
            this.vdtjustificativa = '';
            this.vdtfimjustificativa = '';
            this.vtipo            = 0;
            this.vobs             = '';

            this.vpatharquivos    = '';
            this.lstarquivos      = [];


            $('#cbcolaborador').val(null).trigger('change');

        },

        mtddefault() {
            $('#pnlista').hide();
            this.resetarDados();
            $('#pncadastro').fadeIn(700);
            this.$nextTick(function () {
                if (parseInt(this.opcrud) < 3) {
                    $('#ednome').focus(); // Foco no nome
                } else {
                    $('#btgravar').focus();
                }
            });
        },

        mtdpreparacrud(op) {
            this.opcrud = op;
            this.mtddefault();
        },

        mtdnovo() {
            this.descop        = 'INCLUSÃO'
            this.ativadesativa = false;
            this.mtdpreparacrud(1);
            this.vpatharquivos  = util.GerarStringAleatoria();
        },

        mtdcancelaredicao() {
            this.descop = ''
            this.opcrud = 0;
            $('#pncadastro').hide();
            $('#pnlista').fadeIn(700);
            $('#edconteudopesq').focus();
        },

        mtdgravar() {
            let vself = this;
            Swal.fire({
                title: "Confirmação",
                text: 'Confirma ' + vself.descop + ' DE ' + vself.modulo + '?',
                icon: "warning",
                customClass: {
                    confirmButton: "conf btn btn-success",
                    cancelButton: "btn btn-danger"
                },
                showCancelButton: true,
                confirmButtonColor: "black",
                cancelButtonText: "Não",
                cancelButtonColor: "#d33",
                confirmButtonText: "Sim"
            }).
                then((result) => {
                    if (result.isConfirmed) {
                        $('.conf').prop('disabled', true);
                        vself.mtdregistro();
                    } else {
                        $('#btgravar').focus();
                    }
                });
        },
        mtdlocalizaregistro(id) {
            var vself = this;
            let filtro = ' and j.id=' + id;
            let parametros = [
                { parametro: 'op',        valor: 'listagem' },
                { parametro: 'idusuario', valor: vself.$store.state.usuario.idusuario },
                { parametro: 'idempresa', valor: vself.$store.state.usuario.idempresa },
                { parametro: 'diretorioarquivos',  valor: 'arquivos/justificativas/' + vself.$store.state.usuario.idempresa},
                { parametro: 'filtro',    valor: filtro },
                { parametro: 'limit',     valor: 1 },
                { parametro: 'offset',    valor: 0 },
            ];
            // URL do controlador alterada
            let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/justificativas.php');
            retorno.then(function (response) {
                // Aqui o retorno não está mapeado, para pegar os dados brutos
                let registroBruto = JSON.parse(JSON.stringify(response.data))[0];
                vself.mtdigualarcampos(registroBruto);

                if (parseInt(vself.opcrud) < 3) {
                    $('#ednome').focus();
                } else {
                    $('#btgravar').focus();
                }
            }).catch(function (response) {

            });
        },
        mtdalterar(id) {

            this.descop = 'ALTERAÇÃO'

            this.ativadesativa = false;
            this.mtdpreparacrud(2);
            this.mtdlocalizaregistro(id);

        },
        mtdvisualizar(id) {

            this.descop = 'VISUALIZAÇÃO'

            this.ativadesativa = true;
            this.mtdpreparacrud(4);
            this.mtdlocalizaregistro(id);

        },
        mtdexcluir(id) {

            this.descop = 'EXCLUSÃO'

            this.ativadesativa = true;
            this.mtdpreparacrud(3);
            this.mtdlocalizaregistro(id);

        },
        mtdigualarcampos(registro) { // Mapeamento dos novos campos do registro
            this.vid                 = registro.id;
            this.vtipo               = registro.tipo;
            this.vobs                = registro.obs;  
            this.vdtjustificativa    = registro.dtjustificativa;
            this.vdtfimjustificativa = registro.dtfimjustificativa;
            this.vstatus             = registro.status;

            this.vpatharquivos       = registro.patharquivos !== '' ? registro.patharquivos : util.GerarStringAleatoria();

            this.lstarquivos = this.mtdordenaarquivos(registro.arquivos);

            this.vidcolaborador  = registro.idcolaborador;
            let defcolab         = new Option(registro.nomecolaborador, registro.idcolaborador, true, true);
            $('#cbcolaborador').append(defcolab).trigger('change');

        },
        mtdregistro() {
            let vself = this;
            // Inclui os novos campos para envio ao backend
            let registrocrud = {
                'id'  : this.vid,
                'tipo': this.vtipo,
                'obs' : this.vobs,
                'idcolaborador'  : this.vidcolaborador,
                'dtjustificativa': this.vdtjustificativa,
                'dtfimjustificativa': this.vdtfimjustificativa,
                'patharquivos'  : this.vpatharquivos,
                'status': this.vstatus,
            };
            let parametros = [
                { parametro: 'op',        valor: 'rotinacrud' },
                { parametro: 'opcrud',    valor: vself.opcrud },
                { parametro: 'idempresa', valor: vself.$store.state.usuario.idempresa },
                { parametro: 'registro',  valor: JSON.stringify(registrocrud) },
                { parametro: 'idusuario', valor: vself.$store.state.usuario.idusuario },
            ];
            // URL do controlador alterada
            let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/justificativas.php'); 
            retorno.then(function (response) {
                if ($.isNumeric(response.data)) {
                    util.notif('success', 'Informação!', 'Registro processado com sucesso!');
                    vself.pfiltro = 0;
                    vself.pconteudo = parseInt(vself.opcrud) === 1 ? response.data : vself.vid;
                    vself.pqtd_paginas = 1;
                    vself.mtdcancelaredicao();
                    vself.mtdcarregaitem(1);
                } else {
                    let tpret = response.data.substring(0, 1);
                    switch (tpret) {
                        case 'I':
                            util.notif('error', 'Informação!', response.data.substring(4));
                            break;
                        case 'E': default:
                            util.notif('error', 'Informação!', response.data.substring(4));
                            break;
                    }
                }
            }).catch(function (response) {
                alert('Erro ao processar o registo. Descrição do erro: ' + response.message)
            });
        },

    },
    computed: {
        validou() {
        
            return this.vobs == '' || this.vidcolaborador == null  || this.vdtjustificativa == "" || this.vdtfimjustificativa == "";
        }
    },
    mounted() {


        let vself = this;

        $loading.show()
        setTimeout(() => {

            this.$loading.hide()
            this.mtdexecutapesquisa();
        }
            , 1000)
        $('#pncadastro').hide();


        $("#cbcolaborador").select2({
            id: function (e) { return e.id },
            ajax: {
                url: util.servidor+'/controller/select2sql.php',
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        q: params.term,
                        idempresa: vself.$store.state.usuario.idempresa,
                        sqlini: 'select id, nome from tbcolaboradores ',
                        sqlfim: '',
                        cpid: 'id',
                        cpdesc: 'nome'
                    };
                },
                processResults: function (data) {
                    return {
                        results: data
                    };
                },
                cache: true
            },
            minimumInputLength: 0,
            theme: 'bootstrap',
            language: "pt-BR",
            templateResult: util.formatResult,
            templateSelection: util.formatSelection
        }).change(function () {
            vself.vidcolaborador = $("#cbcolaborador").val();
        });

    },
    watch: {
        pagina_atual(val) {
            this.mtdcarregaitem(val)
        }
    }
}
</script>
<style>
/* ... (Estilos CSS permanecem os mesmos) ... */
.pagination-container {
    display: flex;

    column-gap: 10px;
}

.paginate-buttons {


    border-radius: 20px;

    display: flex;

    cursor: pointer;

    background-color: rgb(242, 242, 242);

    border: 1px solid rgb(217, 217, 217);

    font-size: small;

    color: black;
}

.paginate-buttons:hover {
    background-color: #d8d8d8;
}

.active-page {
    background-color: #13534a;

    border: 1px solid #13534a;

    color: white;
}

.active-page:hover {
    background-color: #13534a;
}

.b-crud {
    font-size: 14px;
    padding: 5px 10px;
    border-radius: 12px;
    width: 100%;
}

</style>